var map = {
	"./Spin360_TorreOvaloB_001.jpg": 24058,
	"./Spin360_TorreOvaloB_002.jpg": 34110,
	"./Spin360_TorreOvaloB_003.jpg": 73757,
	"./Spin360_TorreOvaloB_004.jpg": 96029,
	"./Spin360_TorreOvaloB_005.jpg": 83963,
	"./Spin360_TorreOvaloB_006.jpg": 5046,
	"./Spin360_TorreOvaloB_007.jpg": 32954,
	"./Spin360_TorreOvaloB_008.jpg": 85883,
	"./Spin360_TorreOvaloB_009.jpg": 26892,
	"./Spin360_TorreOvaloB_010.jpg": 34990,
	"./Spin360_TorreOvaloB_011.jpg": 16482,
	"./Spin360_TorreOvaloB_012.jpg": 29739,
	"./Spin360_TorreOvaloB_013.jpg": 77923,
	"./Spin360_TorreOvaloB_014.jpg": 98156,
	"./Spin360_TorreOvaloB_015.jpg": 53429,
	"./Spin360_TorreOvaloB_016.jpg": 42929,
	"./Spin360_TorreOvaloB_017.jpg": 96621,
	"./Spin360_TorreOvaloB_018.jpg": 27447,
	"./Spin360_TorreOvaloB_019.jpg": 90071,
	"./Spin360_TorreOvaloB_020.jpg": 47232,
	"./Spin360_TorreOvaloB_021.jpg": 16872,
	"./Spin360_TorreOvaloB_022.jpg": 41493,
	"./Spin360_TorreOvaloB_023.jpg": 63431,
	"./Spin360_TorreOvaloB_024.jpg": 65448,
	"./Spin360_TorreOvaloB_025.jpg": 64232,
	"./Spin360_TorreOvaloB_026.jpg": 10557,
	"./Spin360_TorreOvaloB_027.jpg": 39815,
	"./Spin360_TorreOvaloB_028.jpg": 27327,
	"./Spin360_TorreOvaloB_029.jpg": 48743,
	"./Spin360_TorreOvaloB_030.jpg": 53624,
	"./Spin360_TorreOvaloB_031.jpg": 62931,
	"./Spin360_TorreOvaloB_032.jpg": 40346,
	"./Spin360_TorreOvaloB_033.jpg": 16618,
	"./Spin360_TorreOvaloB_034.jpg": 90202,
	"./Spin360_TorreOvaloB_035.jpg": 48684,
	"./Spin360_TorreOvaloB_036.jpg": 92222,
	"./Spin360_TorreOvaloB_037.jpg": 81657,
	"./Spin360_TorreOvaloB_038.jpg": 54469,
	"./Spin360_TorreOvaloB_039.jpg": 58715,
	"./Spin360_TorreOvaloB_040.jpg": 81619,
	"./Spin360_TorreOvaloB_041.jpg": 19802,
	"./Spin360_TorreOvaloB_042.jpg": 8990,
	"./Spin360_TorreOvaloB_043.jpg": 5645,
	"./Spin360_TorreOvaloB_044.jpg": 11227,
	"./Spin360_TorreOvaloB_045.jpg": 16489,
	"./Spin360_TorreOvaloB_046.jpg": 34002,
	"./Spin360_TorreOvaloB_047.jpg": 9936,
	"./Spin360_TorreOvaloB_048.jpg": 88220,
	"./Spin360_TorreOvaloB_049.jpg": 44209,
	"./Spin360_TorreOvaloB_050.jpg": 14431,
	"./Spin360_TorreOvaloB_051.jpg": 93595,
	"./Spin360_TorreOvaloB_052.jpg": 34794,
	"./Spin360_TorreOvaloB_053.jpg": 17729,
	"./Spin360_TorreOvaloB_054.jpg": 65714,
	"./Spin360_TorreOvaloB_055.jpg": 46385,
	"./Spin360_TorreOvaloB_056.jpg": 69111,
	"./Spin360_TorreOvaloB_057.jpg": 12167,
	"./Spin360_TorreOvaloB_058.jpg": 63999,
	"./Spin360_TorreOvaloB_059.jpg": 25809,
	"./Spin360_TorreOvaloB_060.jpg": 88557,
	"./Spin360_TorreOvaloB_061.jpg": 33320,
	"./Spin360_TorreOvaloB_062.jpg": 70012,
	"./Spin360_TorreOvaloB_063.jpg": 39133,
	"./Spin360_TorreOvaloB_064.jpg": 76832,
	"./Spin360_TorreOvaloB_065.jpg": 66410,
	"./Spin360_TorreOvaloB_066.jpg": 25245,
	"./Spin360_TorreOvaloB_067.jpg": 787,
	"./Spin360_TorreOvaloB_068.jpg": 32589,
	"./Spin360_TorreOvaloB_069.jpg": 96968,
	"./Spin360_TorreOvaloB_070.jpg": 52524,
	"./Spin360_TorreOvaloB_071.jpg": 84374,
	"./Spin360_TorreOvaloB_072.jpg": 37762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5266;